export enum ModalActions {
  ADD = 'add',
  EDIT = 'edit',
  DELETE = 'delete',
  ACTIVATE = 'activate',
}
